var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errorMsg ||
    [2, 3, 4, 5, 6, 7, 8, 9, 10, 11].indexOf(_vm.currentBetSlipState) > -1
    ? _c(
        "div",
        { staticClass: "betSlipMsgs", class: { inRefferal: _vm.inRefferal } },
        [
          _vm.betsNo
            ? _c(
                "div",
                {
                  staticClass: "betPlacement",
                  class: { bet_placed: _vm.betSlipStatus.State == 2 }
                },
                [
                  _vm.currentBetSlipState == 9 || _vm.errorMsg
                    ? _c("div", { staticClass: "align-center" }, [
                        _vm.errorMsg
                          ? _c(
                              "div",
                              {
                                staticClass: "errorMsg errorId",
                                class: _vm.errorId
                              },
                              [
                                _c("v-icon", [_vm._v("info_outline")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { key: _vm.errorId, staticClass: "message" },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.errorMsg)
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.otherErrorMsg
                          ? _c(
                              "div",
                              { staticClass: "errorMsg otherErrorMsg" },
                              [
                                _c("v-icon", [_vm._v("info_outline")]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "message",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.otherErrorMsg)
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !(_vm.errorMsg || _vm.otherErrorMsg)
                          ? _c(
                              "div",
                              { staticClass: "errorMsg errorGeneric" },
                              [
                                _c("v-icon", [_vm._v("info_outline")]),
                                _vm._v(" "),
                                _c("span", { staticClass: "message" }, [
                                  _vm._v(_vm._s(_vm.$t("BetSlip.status.error")))
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 2
                    ? _c("div", { staticClass: "align-center" }, [
                        _c("div", { staticClass: "loading withcounter" }, [
                          _c("span", { staticClass: "placingbet_msg" }, [
                            _vm._v(_vm._s(_vm.$t("BetSlip.status.placing-in")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("circle-loader-with-counter", {
                                attrs: { n: _vm.inRunningDelay }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 3 ||
                  _vm.currentBetSlipState == 10 ||
                  _vm.currentBetSlipState == 11
                    ? _c(
                        "div",
                        { staticClass: "align-center" },
                        [
                          _vm.inRefferal
                            ? _c("h3", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.status.acceptable.referred.reOffered"
                                      )
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.inRefferal
                            ? _c(
                                "div",
                                {
                                  staticClass: "msg",
                                  class: { inRefferal: _vm.inRefferal }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BetSlip.betPlacementStatus.Status.detailed.referred.reOffered"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("circle-loader")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 4
                    ? _c(
                        "div",
                        { staticClass: "align-center" },
                        [_c("dots-loader")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 5
                    ? _c("div", [
                        !_vm.isFastBet && _vm.betSlipStatus.State == 2
                          ? _c(
                              "div",
                              { staticClass: "Bet-Accepted align-center" },
                              [
                                _vm.brandKey === "rw"
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.setTabFromBetSlip(
                                              "HistoryActive"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "bet_placed_img",
                                          attrs: {
                                            src: require("@/assets/images/brands/rw/PlacedBetSign.svg"),
                                            alt: "Betslip"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brandLayout === "generic" ||
                                _vm.brandKey === "sb" ||
                                _vm.brandKey === "mav" ||
                                _vm.brandKey === "qcasino"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "bet_placed_icon",
                                        on: {
                                          click: function($event) {
                                            return _vm.setTabFromBetSlip(
                                              "HistoryActive"
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("done")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("h3", [
                                  _vm.numberOfSucessfulyPlacedBets == 1
                                    ? _c("span", { key: "betplacedsing" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.status.placed")
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.numberOfSucessfulyPlacedBets > 1
                                    ? _c("span", { key: "betplacedpl" }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.status.placed.pl",
                                                {
                                                  n:
                                                    _vm.numberOfSucessfulyPlacedBets
                                                }
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.numberOfSucessfulyPlacedBets <
                                  _vm.numberOfAttemptedBets
                                    ? _c("span", [
                                        _c("br"),
                                        _vm._v(" "),
                                        _vm.numberOfAttemptedBets -
                                          _vm.numberOfSucessfulyPlacedBets ==
                                        1
                                          ? _c(
                                              "span",
                                              { key: "betfailedsing" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.status.placed.failed"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _c("span", { key: "betfailedpl" }, [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.status.placed.failed.pl",
                                                      {
                                                        n:
                                                          _vm.numberOfAttemptedBets -
                                                          _vm.numberOfSucessfulyPlacedBets
                                                      }
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "align-center" }, [
                                  _c(
                                    "span",
                                    { staticClass: "keep_selections" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "clickable",
                                          on: {
                                            click: function($event) {
                                              return _vm.keepSelections()
                                            }
                                          }
                                        },
                                        [
                                          _vm.betsNo == 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.placement.span.KEEP"
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.betsNo > 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.placement.span.KEEP.pl",
                                                      { n: _vm.betsNo }
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-icon", [
                                            _vm._v("keyboard_arrow_right")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.isLoggedIn &&
                                _vm.playerFavorites &&
                                _vm.favoriteCandidates &&
                                _vm.favoriteCandidates.length > 0
                                  ? _c(
                                      "v-expansion-panel",
                                      {
                                        staticClass: "favorites_betslip",
                                        model: {
                                          value: _vm.expandedItem,
                                          callback: function($$v) {
                                            _vm.expandedItem = $$v
                                          },
                                          expression: "expandedItem"
                                        }
                                      },
                                      [
                                        _c(
                                          "v-expansion-panel-content",
                                          {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "header",
                                                  fn: function() {
                                                    return [
                                                      _vm.expandedItem !== 0
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Favorites.Betslip.Title"
                                                                  )
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.expandedItem === 0
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Favorites.Betslip.Hide"
                                                                  )
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              1507750814
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Favorites.Betslip.Desc1"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Favorites.Betslip.Desc2"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.favoriteCandidates &&
                                            _vm.favoriteCandidates.length > 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "favorites" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "favorites-header"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col col-1"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "label"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Favorites.Betslip.Team_Player"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col col-2"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "label"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Favorites.Betslip.Favorite"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "label"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Favorites.Betslip.NotifyMe"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.favoriteCandidates,
                                                      function(favorit, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "favorite-item"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col col-1"
                                                              },
                                                              [
                                                                _c("icon", {
                                                                  attrs: {
                                                                    name:
                                                                      "icon-" +
                                                                      ((favorit.idfosporttype &&
                                                                        favorit.idfosporttype.replace(
                                                                          / /g,
                                                                          ""
                                                                        )) ||
                                                                        "empty")
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("div", [
                                                                  favorit.type ===
                                                                    "P" ||
                                                                  favorit.type ===
                                                                    "C"
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "label"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              favorit.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  favorit.type ===
                                                                    "S" ||
                                                                  favorit.type ===
                                                                    "L"
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "label"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              favorit.idfosporttype
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col col-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      label: ""
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.saveFavorite(
                                                                          {
                                                                            source:
                                                                              favorit.source,
                                                                            type:
                                                                              favorit.type,
                                                                            idfosporttype:
                                                                              favorit.idfosporttype,
                                                                            favoriteid:
                                                                              favorit.favoriteid,
                                                                            name: favorit.name
                                                                              ? favorit.name
                                                                              : null,
                                                                            order:
                                                                              favorit.order,
                                                                            language:
                                                                              favorit.language,
                                                                            enabled: favorit.enabled
                                                                              ? true
                                                                              : false,
                                                                            tonotify: favorit.tonotify
                                                                              ? true
                                                                              : false
                                                                          }
                                                                        )
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        favorit.enabled,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          favorit,
                                                                          "enabled",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "favorit.enabled"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col col-3"
                                                              },
                                                              [
                                                                favorit.tonotify !==
                                                                null
                                                                  ? _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "",
                                                                          disabled: !favorit.enabled
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.saveFavorite(
                                                                              {
                                                                                source:
                                                                                  favorit.source,
                                                                                type:
                                                                                  favorit.type,
                                                                                idfosporttype:
                                                                                  favorit.idfosporttype,
                                                                                favoriteid:
                                                                                  favorit.favoriteid,
                                                                                name: favorit.name
                                                                                  ? favorit.name
                                                                                  : null,
                                                                                order:
                                                                                  favorit.order,
                                                                                language:
                                                                                  favorit.language,
                                                                                enabled: favorit.enabled
                                                                                  ? true
                                                                                  : false,
                                                                                tonotify: favorit.tonotify
                                                                                  ? true
                                                                                  : false
                                                                              }
                                                                            )
                                                                          }
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            favorit.tonotify,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              favorit,
                                                                              "tonotify",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "favorit.tonotify"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "totals" }, [
                                  _vm.betPlacementResult.ExternalReference
                                    ? _c("div", { staticClass: "reference" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.receipt.reference"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.betPlacementResult
                                                .ExternalReference
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "wagered" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.receipt.wagered")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.betPlacementResult.TotalStake.toFixed(
                                                2
                                              )
                                            )
                                          )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.totalVoucherDiscount
                                    ? _c(
                                        "div",
                                        { staticClass: "wagered bonus" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.receipt.promotions.totalDiscount"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    _vm.totalVoucherDiscount.toFixed(
                                                      2
                                                    )
                                                  )
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.usedVoucher && !_vm.totalVoucherDiscount
                                    ? _c(
                                        "div",
                                        { staticClass: "wagered bonus" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.receipt.promotions.used"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.usedVoucher.Description
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.totalVoucherDiscount
                                    ? _c(
                                        "div",
                                        { staticClass: "actual-wagered bonus" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.receipt.wagered.discounted"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    (
                                                      _vm.betPlacementResult
                                                        .TotalStake -
                                                      _vm.totalVoucherDiscount
                                                    ).toFixed(2)
                                                  )
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showSOBonusOnReceipt &&
                                  (_vm.soBonus.val ||
                                    (_vm.soBonus.names &&
                                      _vm.soBonus.names.length))
                                    ? _c(
                                        "div",
                                        { staticClass: "potential-bonus" },
                                        [
                                          _c("label", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.receipt.bonus.potential"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.showSOBonusNameOnReceipt &&
                                            _vm.soBonus.names &&
                                            _vm.soBonus.names.length
                                              ? _c(
                                                  "span",
                                                  { staticClass: "bonusLabel" },
                                                  [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          _vm.soBonus.names.join(
                                                            ", "
                                                          )
                                                        ) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    _vm.soBonus.val
                                                  )
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "potential-return" },
                                    [
                                      _c("label", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.receipt.winning.potential"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.usedVoucher &&
                                        !_vm.usedVoucher.DiscountPercentage &&
                                        !_vm.soBonus.val
                                          ? _c(
                                              "span",
                                              { staticClass: "bonusLabel" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.receipt.bonus.notIncluded"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.soBonus.val &&
                                        _vm.showSOWinningInclBonusOnReceipt
                                          ? _c(
                                              "span",
                                              { staticClass: "bonusLabel" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.receipt.bonus.included"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.soBonus.val &&
                                        !_vm.showSOWinningInclBonusOnReceipt
                                          ? _c(
                                              "span",
                                              { staticClass: "bonusLabel" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.receipt.bonus.notIncluded"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm.attemptedBetPotentialReturn +
                                                  (_vm.showSOWinningInclBonusOnReceipt
                                                    ? _vm.soBonus.val
                                                    : 0)
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showSOInsuranceOnReceipt &&
                                  _vm.soBonus.insurance &&
                                  _vm.soBonus.insurance.length
                                    ? _c(
                                        "div",
                                        { staticClass: "line-insurance" },
                                        [
                                          _c("label", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SpecialOffer.PARLAYINSURANCE.eligible"
                                                  )
                                                ) + "\n                  "
                                              ),
                                              _vm.showSOInsuranceNameOnReceipt
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "bonusLabel"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            _vm.soBonus.insurance.join(
                                                              ", "
                                                            )
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.betSlipStatus.State == 4
                          ? _c("div", { staticClass: "Bet-Rejected" }, [
                              _c("h3", [
                                !_vm.errorType
                                  ? _c("span", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.status.rejected")
                                          )
                                        )
                                      ])
                                    ])
                                  : _c("span", [
                                      _c("span", { key: _vm.errorType }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.placement.error." +
                                                _vm.errorType +
                                                ".result",
                                              {
                                                state: _vm.state,
                                                totalBetSlipMinUnit:
                                                  _vm.totalBetSlipMinUnit,
                                                totalStake:
                                                  _vm.betSlipTotals &&
                                                  _vm.betSlipTotals.totalStake
                                              }
                                            )
                                          )
                                        )
                                      ])
                                    ])
                              ]),
                              _vm._v(" "),
                              _vm.statusText && !_vm.errorMsg
                                ? _c("div", { staticClass: "reject-reason" }, [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.statusText)
                                      }
                                    })
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.betSlipStatus.State == 5
                          ? _c(
                              "div",
                              { staticClass: "Bet-Waiting" },
                              [
                                _c("h3", [
                                  _vm.inRefferal
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.status.waiting.reffer"
                                            )
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.status.waiting")
                                          )
                                        )
                                      ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "msg bet_actions_msg",
                                    class: { inRefferal: _vm.inRefferal }
                                  },
                                  _vm._l(
                                    _vm.betSlipStatus.detailedStates,
                                    function(reason) {
                                      return _c("div", [
                                        _vm.inRefferal && reason == "reOffered"
                                          ? _c("span", [
                                              _c(
                                                "span",
                                                {
                                                  key:
                                                    reason + "-" + Math.random()
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.betPlacementStatus.Status.detailed.referred." +
                                                          reason
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.betPlacementStatus.Status.detailed.referred.reOffered.scroll"
                                                    )
                                                  )
                                                )
                                              ])
                                            ])
                                          : _c(
                                              "span",
                                              {
                                                key:
                                                  reason + "-" + Math.random()
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.betPlacementStatus.Status.detailed." +
                                                        reason
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c("circle-loader"),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.betSlipStatus.detailedStates,
                                  function(reason) {
                                    return !_vm.inRefferal
                                      ? _c("div", [
                                          reason == "reOffered"
                                            ? _c("span", { key: reason }, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.betPlacementStatus.Status.detailed.reOffered.call"
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  }
                                )
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 6
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            class: {
                              "Bet-Acceptable": _vm.betSlipStatus.State == 1,
                              "Bet-Reoffered": _vm.betSlipStatus.State == 3,
                              "Bet-Waiting": _vm.betSlipStatus.State == 5
                            }
                          },
                          [
                            _vm.betSlipStatus.State == 5
                              ? _c("h3", [
                                  _vm.inRefferal
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.status.waiting.reffer"
                                            )
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.status.waiting")
                                          )
                                        )
                                      ])
                                ])
                              : _c("h3", [
                                  _vm.betSlipStatus.detailedStates &&
                                  _vm.betSlipStatus.detailedStates.indexOf(
                                    "reOffered"
                                  ) > -1
                                    ? _c("span", [
                                        _vm.inRefferal
                                          ? _c(
                                              "span",
                                              { key: _vm.betSlipStatus.State },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.status.acceptable.referred.reOffered"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              { key: _vm.betSlipStatus.State },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.status.acceptable.reOffered"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                      ])
                                    : _c("span", [
                                        _c(
                                          "span",
                                          { key: _vm.betSlipStatus.State },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.status.acceptable"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "msg bet_actions_msg",
                                class: { inRefferal: _vm.inRefferal }
                              },
                              _vm._l(_vm.betSlipStatus.detailedStates, function(
                                reason
                              ) {
                                return _c("div", [
                                  _vm.inRefferal && reason == "reOffered"
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { key: reason + "-" + Math.random() },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.betPlacementStatus.Status.detailed.referred." +
                                                    reason
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.betPlacementStatus.Status.detailed.referred.reOffered.scroll"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _c(
                                        "span",
                                        { key: reason + "-" + Math.random() },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.betPlacementStatus.Status.detailed." +
                                                  reason
                                              )
                                            )
                                          )
                                        ]
                                      )
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            !_vm.inRefferal
                              ? _c("div", { staticClass: "confirmIn" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("BetSlip.status.confirmIn"))
                                    )
                                  ]),
                                  _vm._v(" " + _vm._s(_vm.gracePeriod))
                                ])
                              : _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "loading withcounter" },
                                    [
                                      _c("circle-loader-with-counter", {
                                        attrs: { n: _vm.gracePeriod }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                            _vm._v(" "),
                            _vm._l(_vm.betSlipStatus.detailedStates, function(
                              reason
                            ) {
                              return !_vm.inRefferal
                                ? _c("div", [
                                    reason == "reOffered"
                                      ? _c("span", { key: reason }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.betPlacementStatus.Status.detailed.reOffered.call"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 7
                    ? _c("div", { staticClass: "align-center" }, [
                        _c("h3", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("BetSlip.status.canceled")))
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 8
                    ? _c("div", { staticClass: "align-center" }, [
                        _c("h3", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("BetSlip.status.timedOut")))
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a07bfd80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a07bfd80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/messages.vue
// module id = null
// module chunks = 